module.exports = __webpack_public_path__ + "img/logo.da2815b8.png";